import React from 'react';
import { observer } from 'mobx-react';
import { routeNode } from 'core/routing';
import { FourOhFour } from 'apps/fourOhFour/index';
import { withNamespaces } from 'react-i18next';
import PropTypes from 'prop-types';

import ProjectsPage from 'apps/projects/page';

const viewsMap = {
  '': ProjectsPage,
};

@withNamespaces()
@observer
class ProjectPageRouter extends React.Component {
  render() {
    const View = this.props.componentFromRoute();
    return <View params={this.props.params} />;
  }
}

ProjectPageRouter.propTypes = {
  route: PropTypes.object,
  params: PropTypes.object,
  componentFromRoute: PropTypes.func,
};

export default routeNode(
  'workspace.spaceProjects',
  viewsMap,
  FourOhFour,
)(ProjectPageRouter);
